import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "../styles/VoucherDisplay.module.scss";
import VoucherTicketAdmin from "../../../components/icon-components/VoucherTicketAdmin";
import CustomButton from "../../../components/custom-button/CustomButton";
import { formatDateMonthDateYear } from "../../../utility/functions/common-functions";
import { REDEMPTION_STATUS_ID_MAPPING } from "../../../utility/constants/common-constants";

interface VoucherDisplayProps {
  tierDisplayName: string;
  redemptionCouponCode: string;
  validTill: string | null;
  tierSequence?: number;
  adminEmail?: string | null;
  redeemedDate?: string | null;
  handleClick?: (values: any) => void;
  redemptionStatusId?: number;
}

const VoucherDisplay: React.FC<VoucherDisplayProps> = ({
  tierDisplayName,
  redemptionCouponCode,
  validTill,
  tierSequence,
  adminEmail,
  redeemedDate,
  handleClick,
  redemptionStatusId,
}) => {
  const getFillColor = (tierSequence: number) => {
    switch (tierSequence) {
      case 2:
        return "#CF489A"; // Tummy Trailblazers
      case 3:
        return "#A41E35"; // Glow Getters
      case 4:
        return "#FDB913"; // Bump Bosses
      case 5:
        return "#FF6200"; // final reward
      default:
        return "#CCCCCC"; // Disabled state
    }
  };

  return (
    <Box className={styles.voucherDisplay}>
      <VoucherTicketAdmin
        width="100%"
        fillColor={
          redemptionStatusId !== REDEMPTION_STATUS_ID_MAPPING.expired
            ? getFillColor(tierSequence || 0)
            : "#CCCCCC"
        }
        leftSection={
          <Box className={styles.leftSection}>
            <Typography variant="h4" fontWeight={500} mb={2}>
              {tierDisplayName}
            </Typography>
            {redemptionStatusId !== REDEMPTION_STATUS_ID_MAPPING.completed ? (
              <Typography fontSize="10px">{`valid untill ${formatDateMonthDateYear(
                validTill || ""
              )}`}</Typography>
            ) : (
              <Box
                display="flex"
                justifyContent="flex-start"
                flexDirection="column"
              >
                <Typography fontSize="10px" fontWeight={500}>
                  Redeemed
                </Typography>
                <Typography fontSize="10px">By: {adminEmail}</Typography>
                <Typography fontSize="10px">On: {redeemedDate}</Typography>
              </Box>
            )}
          </Box>
        }
        rightSection={
          <Box className={styles.rightSection}>
            <Typography fontSize="10px">Voucher Generated</Typography>
            {redemptionStatusId !== REDEMPTION_STATUS_ID_MAPPING.completed && (
              <CustomButton
                text="Accept Voucher"
                variant="outlined"
                sx={{
                  padding: "2px 10px",
                  mt: 1,
                  mb: 2,
                  "&.Mui-disabled": {
                    opacity: 0.5,
                    border: "1px solid #a41e35",
                    color: "#a41e35",
                  },
                }}
                disabled={
                  redemptionStatusId === REDEMPTION_STATUS_ID_MAPPING.expired
                }
                onClick={handleClick}
              />
            )}
          </Box>
        }
      />
    </Box>
  );
};

export default VoucherDisplay;
